﻿import {
    ICluster, IConfirmDashDonation, IDonor, IDonorWithRemoteRecipient, IPosition,
    IReferral, IVoucherDonor, IWageAndTravelRequest, IXmTracking, IMicrositeRecipient, IMicrositeRecipientPendApproval,
    IPassMissingRecipientProfile
} from '..';

export interface IActionCenterOther {
    logisticsKickoffCalls: ICluster[],
    pickups: IPosition[],
    deliveries: IPosition[],
    pendingLogisticOptions: number,
    lostChainStarters: IDonor[],
    pendingReferrals: IReferral[],
    wageAndTravelRequests: IWageAndTravelRequest[],
    voucherDonors: IVoucherDonor[],
    finalXmResults: IXmTracking[],
    donorEvalOutOfDate: IDonor[],
    confirmDashDonations: IConfirmDashDonation[],
    missingPostTransplantData: string[],
    missingCenterProfileData: string[],
    msPatientsPendingApproval: IMicrositeRecipientPendApproval[],
    passMissingRecipientProfiles: IPassMissingRecipientProfile[]
}

export interface IAdminActionCenterOther {
    logisticsCallCount: number,
    kickoffCallCount: number,
    pickupCount: number,
    deliveryCount: number,
    ldPrioritizationCount: number,
    watrRequestCount: number,
    voucherDonorsWithIncompleteVoucherHoldersCount: number,
    incompleteVoucherDonorCount: number
    // lostChainStarters: number,
    // wageAndTravelRequests: number,
    // voucherDonors: number,
    // finalXmResults: number,
    // donorEvalOutOfDate: number,
    // confirmDashDonations: number,
    // missingPostTransplantData: number,
    // missingCenterProfileData: number
}